import React from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateWarehouse } from "../hooks";
import { WarehouseForm } from "../components";

export const CreateWarehouse: React.FC = () => {
  const { form, submit, loading } = useCreateWarehouse({
    defaultValues: { active: true },
    onCompleted: () => {
      toast.success("L'entrepôt a été créé avec succès");
    },
  });

  return (
    <>
      <Header
        title="Entrepôt"
        subtitle="Créer un nouvel entrepôt"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/warehouses`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvel entrepôt" />
          <WarehouseForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
